<template>
	<div class="update-tab">
		<div class="update-content">
			<ul class="tabs">
        <li class="li-tab" v-for="(item,index) in tabsParam"
					@mouseenter="showToggleTabs(index)" @mouseleave="showToggleTabs(index)"
					:class="{ active: index === nowIndex }" :key="index">
					{{item}}
        </li>
      </ul>
			<div class="content-1" v-show="nowIndex === 0">
				<tabPro />
			</div>
			<div class="content-2" v-show="nowIndex === 1">
				<tabSys />
			</div>
		</div>
	</div>
</template>

<script>
	import tabPro from "./tabPro"
	import tabSys from "./tabSys"
	export default {
		components: {
			tabPro,
			tabSys
		},
		data () {
			return {
				total: 0,
				nowIndex: 0,
				tabsParam: [ "项目更新日志", "系统更新日志" ]
			}
		},
		methods: {
			showToggleTabs (index) {
				this.nowIndex = index
			}
		}
	}
</script>

<style lang="scss">
	.update-tab {
		width: 100%;
		min-width: 1200px;
		background-color: #fff;
		padding-left: 10px;
		box-sizing: border-box;
		.update-content {
			width: 1200px;
			height: auto;
			min-width: 1200px;
			margin: 0 auto;
			.tabs {
        width: 100%;
        font: 0;
        padding: 0;
				margin-top: 27px;
				display: flex;
        text-align: center;
        border-bottom: 1px solid #e6e8ee;
        .li-tab {
			cursor: pointer;
			width: 50%;
			height: 100%;
			display:inline-block;
			font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
			width: 108px;
			font-size: 18px;
			font-weight: 400;
			text-align: left;
			color: #333333;
			line-height: 25px;
			white-space: nowrap;
		}
		.active {
			padding-bottom: 18px;
			border-bottom: 1px solid #1a51ff;
			font-size: 18px;
			font-weight: 400;
			font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Semibold";
		}
		li:last-child {
			margin-left: 50px;
		}
      }
			.pages-list {
				width: 100%;
				margin: 40px auto 66px auto;
				.el-pagination {
					text-align: center;
				}
			}
		}
	}
</style>